import { bindStateTabs } from "../consts/stateTabs";

//! @ngInject
export function patientCareAndTaskCtrl(
    $scope,
    $state
) {
    // In the order patient-care-and-task.html renders them. These are also the destinations the
    // AI omnibar offers for this page - see the `tabs` beside it in config.js.
    const tabs = bindStateTabs($scope, $state, [
        "app.patients.careAndTaskManagement.upcomingTasks",
        "app.patients.careAndTaskManagement.careManagement",
        "app.patients.careAndTaskManagement.certificationPeriods",
        "app.patients.careAndTaskManagement.patientsDocuments",
        "app.patients.careAndTaskManagement.tasksNew",
        "app.patients.careAndTaskManagement.tasksV2",
        "app.patients.careAndTaskManagement.rnSchedulingMap"
    ]);

    $scope.goToState = tabs.goToState;
};
